import React, { useState, useEffect } from "react";
import { Dialog, Button, TextInput, Image } from "hesus-ui-kit";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import {
  useGetGeneralParameters,
  useGetMainCurrencyByCountryId,
  useGetMultiUserCurrenciesByCountryId,
} from "@hooks/useGeneralParams";
import Enquiries from "./components/Enquiries/Enquiries";
import CatalogServices from "./components/CatalogServices/CatalogServices";
import ServiceTypeCondition from "./components/ServiceTypeCondition/ServiceTypeCondition";
import { textReplace, twoDecimalPlaces } from "@utils/utils";
import { priceTypes } from "@utils/constants";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  styles,
  ErrorMessage,
  EnquiryCatalogContainer,
  GridRow,
  CurrencyBanner,
  ExchangeRateLabel,
  ExchangeRateWrapper,
  ExchangeContainer,
} from "./AddEditSellingPrice.styled";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";

import closeIcon from "@icons/ic-close-white.svg";

const AddEditSellingPrice = (props) => {
  const {
    t,
    isEditMode,
    id,
    onRefreshData,
    onClose,
    sellingPriceData,
    enquiryData,
    enquiryId,
    isJobsite,
    selectedSolutionsIds,
    page,
    siteData,
    updateEnquiryInfo,
    countryId,
  } = props;

  const [sellingPriceSaveAPIError, setSellingPriceSaveAPIError] = useState("");
  const [previousServiceType, setPreviousServiceType] = useState([]);
  const [isSellingPriceSaving, setSellingPriceSaveStatus] = useState(false);
  const [isUpdatePriceField, setUpdatePriceField] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [loadEditForm, setLoadEditForm] = useState(true);
  const [allCatalogServiceList, setAllCatalogServiceList] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [products, setProducts] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [productFetch, setProductFetch] = useState(false);
  const [solutionIds, setSolutionIds] = useState(selectedSolutionsIds);
  const [productsAPIError, setProductsAPIError] = useState("");
  const [transportList, setTransportList] = useState([]);
  const [isTransportAPIError, setTransportAPIError] = useState(false);
  const [formDataUpdate, setFormDataUpdate] = useState(false);
  const [isCurrencyChange, setIsCurrencyChange] = useState(false);

  const generalParams = useGetGeneralParameters();
  const currencyList = generalParams.countryCurrency;
  const { countryCurrencyPosition } = generalParams;
  const mainCurrency = useGetMainCurrencyByCountryId(countryId);
  const userCurrency = useGetMultiUserCurrenciesByCountryId(countryId);
  // solution listing
  const [solutionListAPIError, setSellingPriceSolutionsAPIError] = useState("");

  const [catalogServiceId, setCatalogServiceId] = useState([]);
  const [catalogServiceIdSolutionApi, setCatalogServiceIdSolutionApi] =
    useState([]);

  // exchange rate feature code
  const [exchangeRate, setExchangeRate] = useState([]);
  const [exchangeCurrency, setExchangeCurrency] = useState([]);
  const [calculateUpp, setCalculateUpp] = useState(false);

  const sellingPriceListByIds = useSelector(
    (state) => state.sellingPricesList.byId
  );

  const userDetails = UserInfo.getUser();

  const countryNeedSolution = useSelector((state) =>
    generalParams.countryList.find(
      (countryInfo) => parseInt(countryInfo.id, 10) === countryId
    )
  );

  let selectedSellingPrice = [];
  if (sellingPriceData !== null) selectedSellingPrice = sellingPriceData;
  else selectedSellingPrice = sellingPriceListByIds[id];

  const [formData, setFormData] = useState({
    requestId: {
      value: parseInt(enquiryData?.id, 10),
      error: "",
      required: true,
    },
    catalogService: {
      value: selectedSellingPrice?.hesusCatalog?.id
        ? parseInt(selectedSellingPrice?.hesusCatalog.id, 10)
        : "",
      error: "",
      required: true,
    },
    currency: {
      value:
        selectedSellingPrice?.currency?.id ?? parseInt(mainCurrency, 10) ?? "",
      error: "",
      required: true,
    },
    label: {
      value: selectedSellingPrice?.label ?? "",
      error: "",
      required: true,
    },
    internalComment: {
      value: selectedSellingPrice?.internalComment ?? "",
      error: "",
      required: true,
    },
    isActive: {
      value: selectedSellingPrice?.isActive ?? "",
      error: "",
      required: true,
    },
  });

  const onInternalCommentChange = (e) => {
    setFormData({
      ...formData,
      internalComment: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  useEffect(() => {
    if (isEditMode) setIsDisabled(!selectedSellingPrice.isEditable);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEnquirySelect = (selectedRequest) => {
    setFormData({
      ...formData,
      requestId: {
        value: parseInt(selectedRequest, 10),
        error: "",
        required: true,
      },
    });
    updateEnquiryInfo(selectedRequest);
  };

  useEffect(() => {
    if (formData.catalogService.value && allCatalogServiceList.length > 0) {
      const selectedCatalogService = allCatalogServiceList.find(
        (catalog) =>
          parseInt(formData.catalogService.value, 10) ===
          parseInt(catalog.id, 10)
      );
      if (!loadEditForm || !isEditMode) {
        const catalogServiceIds = [];
        const newSolutionIds = [];
        // const solutionIdsList = solutionIds;
        const responseData = selectedCatalogService?.hesusServices.map(
          (service) => {
            const previousServiceValue = previousServiceType[
              service.hesusService.id
            ]
              ? previousServiceType[service.hesusService.id]
              : [];
            catalogServiceIds.push(service.id);
            // const solutionIndex = solutionIds.indexOf(
            //   parseInt(service.hesusService.id, 10)
            // );
            const solutionExist = solutionIds.find(
              (solution, id) =>
                parseInt(id, 10) === parseInt(service.hesusService.id, 10)
            );
            if (!newSolutionIds[parseInt(service.hesusService.id, 10)])
              newSolutionIds[parseInt(service.hesusService.id, 10)] = [];
            if (solutionExist !== undefined && solutionExist.length > 0) {
              newSolutionIds[parseInt(service.hesusService.id, 10)] =
                solutionIds[parseInt(service.hesusService.id, 10)];
            }
            const tempData = {
              hesusCatalogServiceId: service.id,
              hesusCatalogServiceCombination: service.combination,
              hesusServiceInfo: service.hesusService,

              serviceField: {
                sellingPriceItemId: {
                  value: previousServiceValue?.sellingPriceItemId
                    ? previousServiceValue?.sellingPriceItemId.value
                    : "",
                  error: "",
                  required: true,
                  name: "id_" + service.id,
                },
                quantity: {
                  value: previousServiceValue?.quantity
                    ? previousServiceValue?.quantity.value
                    : "",
                  error: "",
                  required: true,
                  name: "quantity_" + service.id,
                },
                unit: {
                  value: previousServiceValue?.unit
                    ? previousServiceValue?.unit.value
                    : "",
                  error: "",
                  required: true,
                  name: "unit_" + service.id,
                },
                purchasePrice: {
                  value: previousServiceValue?.purchasePrice
                    ? previousServiceValue?.purchasePrice.value
                    : 0,
                  error: "",
                  required: true,
                  name: "purchasePrice_" + service.id,
                },
                estimatedPurchasePrice: {
                  value: previousServiceValue?.estimatedPurchasePrice
                    ? previousServiceValue?.estimatedPurchasePrice.value
                    : "",
                  error: "",
                  required: true,
                  name: "estimatedPurchasePrice_" + service.id,
                },
                estimatedPurchasePriceToggle: {
                  value: !!previousServiceValue?.estimatedPurchasePrice,
                  error: "",
                  required: true,
                  name: "estimatedPurchasePriceToggle_" + service.id,
                },
                product: {
                  value: previousServiceValue?.product
                    ? previousServiceValue?.product.value
                    : "",
                  error: "",
                  required: true,
                  name: "product_" + service.id,
                },
                transport: {
                  value: previousServiceValue?.transport
                    ? previousServiceValue?.transport.value
                    : "",
                  error: "",
                  required: true,
                  name: "transport_" + service.id,
                },
                destination: {
                  value: previousServiceValue?.destination
                    ? previousServiceValue?.destination.value
                    : "",
                  error: "",
                  required: true,
                  name: "destination_" + service.id,
                },
                unitPrice: {
                  value:
                    previousServiceValue?.unitPrice ||
                    previousServiceValue?.unitPrice === 0
                      ? previousServiceValue?.unitPrice.value
                      : "",
                  error: "",
                  required: true,
                  name: "unitPrice_" + service.id,
                },
                totalPrice: {
                  value:
                    previousServiceValue?.totalPrice ||
                    previousServiceValue?.totalPrice === 0
                      ? previousServiceValue?.totalPrice.value
                      : "",
                  error: "",
                  required: true,
                  name: "totalPrice_" + service.id,
                },
                margin: {
                  value:
                    previousServiceValue?.margin ||
                    previousServiceValue?.margin === 0
                      ? previousServiceValue?.margin.value
                      : null,
                  error: "",
                  required: true,
                  name: "margin_" + service.id,
                },
                marginRate: {
                  value:
                    previousServiceValue?.marginRate ||
                    previousServiceValue?.marginRate === 0
                      ? previousServiceValue?.marginRate.value
                      : null,
                  error: "",
                  required: true,
                  name: "marginRate_" + service.id,
                },
                comment: {
                  value: previousServiceValue?.comment
                    ? previousServiceValue?.comment.value
                    : "",
                  error: "",
                  required: true,
                  name: "comment_" + service.id,
                },
                solutionList: {
                  value: previousServiceValue?.solutionList
                    ? previousServiceValue?.solutionList.value
                    : [],
                  error: "",
                  required: true,
                  name: "solution_" + service.id,
                },
                selectedSolutionId: {
                  value: previousServiceValue?.selectedSolutionId
                    ? previousServiceValue?.selectedSolutionId.value
                    : [],
                  error: "",
                  required: true,
                  name: "selectedSolutionId_" + service.id,
                },
              },
            };
            return tempData;
          }
        );
        setCatalogServiceId(catalogServiceIds);
        setSolutionIds(newSolutionIds);
        setServiceType([...responseData]);
        setPreviousServiceType([]);
        setFormDataUpdate(true);
      }

      if (loadEditForm && isEditMode) {
        const catalogServiceIds = [];
        const newSolutionIds = [];
        const responseData = selectedCatalogService?.hesusServices.map(
          (service) => {
            const formEditData = selectedSellingPrice.services.find(
              (catalog) =>
                parseInt(service.id, 10) ===
                parseInt(catalog.hesusCatalogService.id, 10)
            );
            catalogServiceIds.push(service.id);
            // const solutionIndex = solutionIds.indexOf(
            //   parseInt(service.hesusService.id, 10)
            // );
            const solutionExist = solutionIds.find(
              (solution, id) =>
                parseInt(id, 10) === parseInt(service.hesusService.id, 10)
            );

            if (!newSolutionIds[parseInt(service.hesusService.id, 10)]) {
              newSolutionIds[parseInt(service.hesusService.id, 10)] = [];
            }
            if (solutionExist !== undefined && solutionExist.length > 0) {
              newSolutionIds[parseInt(service.hesusService.id, 10)] =
                solutionIds[parseInt(service.hesusService.id, 10)];
            }
            const tempData = {
              hesusCatalogServiceId: service.id,
              hesusCatalogServiceCombination: service.combination,
              hesusServiceInfo: service.hesusService,

              serviceField: {
                sellingPriceItemId: {
                  value: formEditData?.id ? formEditData?.id : null,
                  error: "",
                  required: true,
                  name: "id_" + service.id,
                },
                quantity: {
                  value: formEditData?.quantity ? formEditData?.quantity : "",
                  error: "",
                  required: true,
                  name: "quantity_" + service.id,
                },
                unit: {
                  value: formEditData?.unit ? formEditData?.unit : "",
                  error: "",
                  required: true,
                  name: "unit_" + service.id,
                },
                purchasePrice: {
                  value: formEditData?.purchasePrice
                    ? formEditData?.purchasePrice
                    : 0,
                  error: "",
                  required: true,
                  name: "purchasePrice_" + service.id,
                },
                estimatedPurchasePrice: {
                  value: formEditData?.estimatedPurchasePrice
                    ? formEditData?.estimatedPurchasePrice
                    : "",
                  error: "",
                  required: true,
                  name: "estimatedPurchasePrice_" + service.id,
                },
                estimatedPurchasePriceToggle: {
                  value: !!formEditData?.estimatedPurchasePrice,
                  error: "",
                  required: true,
                  name: "estimatedPurchasePriceToggle_" + service.id,
                },
                product: {
                  value: formEditData?.product?.id
                    ? formEditData?.product.id
                    : "",
                  error: "",
                  required: true,
                  name: "product_" + service.id,
                },
                transport: {
                  value: formEditData?.transportType?.id
                    ? formEditData?.transportType.id
                    : "",
                  error: "",
                  required: true,
                  name: "transport_" + service.id,
                },
                destination: {
                  value: formEditData?.destination
                    ? formEditData.destination
                    : "",
                  error: "",
                  required: true,
                  name: "destination_" + service.id,
                },
                unitPrice: {
                  value:
                    formEditData?.unitPrice || formEditData?.unitPrice === 0
                      ? formEditData?.unitPrice
                      : "",
                  error: "",
                  required: true,
                  name: "unitPrice_" + service.id,
                },
                totalPrice: {
                  value:
                    formEditData?.totalPrice || formEditData?.totalPrice === 0
                      ? formEditData?.totalPrice
                      : "",
                  error: "",
                  required: true,
                  name: "totalPrice_" + service.id,
                },
                margin: {
                  value:
                    formEditData?.margin || formEditData?.margin === 0
                      ? formEditData?.margin
                      : null,
                  error: "",
                  required: true,
                  name: "margin_" + service.id,
                },
                marginRate: {
                  value:
                    formEditData?.marginRate || formEditData?.marginRate === 0
                      ? formEditData?.marginRate
                      : null,
                  error: "",
                  required: true,
                  name: "marginRate_" + service.id,
                },
                comment: {
                  value: formEditData?.comment ? formEditData?.comment : "",
                  error: "",
                  required: true,
                  name: "comment_" + service.id,
                },
                solutionList: {
                  value: formEditData?.solutionList?.value
                    ? formEditData?.solutionList?.value
                    : [],
                  error: "",
                  required: true,
                  name: "solution_" + service.id,
                },
                selectedSolutionId: {
                  value: formEditData?.selectedSolutionId
                    ? formEditData?.selectedSolutionId
                    : [],
                  error: "",
                  required: true,
                  name: "selectedSolutionId_" + service.id,
                },
              },
            };
            return tempData;
          }
        );
        const rates = [];
        const excahngeCurrencyList = [];
        if (
          selectedSellingPrice?.exchangeRates &&
          selectedSellingPrice?.exchangeRates.length > 0
        ) {
          selectedSellingPrice?.exchangeRates.map((exchange) => {
            rates.push({
              exchangeRateId: exchange?.id,
              id: exchange?.currencyFrom,
              rate: exchange.exchangeRate,
              error: "",
            });
            excahngeCurrencyList.push(parseInt(exchange?.currencyFrom, 10));
          });
        }
        setSolutionIds(newSolutionIds);
        setLoadEditForm(false);
        setServiceType([...responseData]);
        setPreviousServiceType([]);
        setCatalogServiceId(catalogServiceIds);
        if (rates?.length > 0) {
          setExchangeRate([...rates]);
          setExchangeCurrency([...excahngeCurrencyList]);
        }
        setFormDataUpdate(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.catalogService.value, allCatalogServiceList]);

  useEffect(() => {
    const existingServiceData = [];
    serviceType.map((service) => {
      existingServiceData[service.hesusServiceInfo.id] = service.serviceField;
    });
    setPreviousServiceType(existingServiceData);
  }, [serviceType]);

  useEffect(() => {
    if (isUpdatePriceField) {
      let curService = null;
      let curIndex = null;
      const responseData = serviceType.map((service, index) => {
        const tempData = { ...service };
        if (
          parseInt(service.hesusCatalogServiceId, 10) ===
          parseInt(isUpdatePriceField, 10)
        ) {
          curService = service;
          curIndex = index;
          const unitPrice =
            service.serviceField.unitPrice.value ||
            service.serviceField.unitPrice.value === 0
              ? textReplace(service.serviceField.unitPrice.value, ",", ".")
              : "";
          const quantity =
            service.serviceField.quantity.value ||
            service.serviceField.quantity.value === 0
              ? textReplace(service.serviceField.quantity.value, ",", ".")
              : "";
          if (unitPrice && quantity) {
            tempData.serviceField.totalPrice = {
              value:
                parseFloat(unitPrice, 10) * parseInt(quantity, 10).toFixed(2),
              error: "",
              required: true,
              name: "totalPrice_" + isUpdatePriceField,
            };
          }
          if (quantity) {
            service.serviceField.solutionList.value.map(
              (solutionInfo, solutionIndex) => {
                const newAllocation =
                  tempData.serviceField.solutionList.value[solutionIndex]
                    .solution.allocation;
                if (newAllocation) {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.allocationQuantity = twoDecimalPlaces(
                    (newAllocation * quantity) / 100
                  );
                }
              }
            );
          }
          if (!service.hesusServiceInfo.needSolution) {
            tempData.serviceField.margin = {
              value: parseFloat(unitPrice, 10),
              error: "",
              required: true,
              name: "margin_" + isUpdatePriceField,
            };
            tempData.serviceField.marginRate = {
              value: 100,
              error: "",
              required: true,
              name: "marginRate_" + isUpdatePriceField,
            };
            if (tempData.hesusServiceInfo.needSolution) {
              tempData.serviceField.purchasePrice = {
                value: null,
                error: "",
                required: false,
                name: "purchasePrice_" + isUpdatePriceField,
              };
            }
            tempData.serviceField.estimatedPurchasePrice = {
              value: null,
              error: "",
              required: false,
              name: "estimatedPurchasePrice_" + isUpdatePriceField,
            };
          }
        }
        return tempData;
      });
      setServiceType([...responseData]);
      if (curService !== null && curIndex !== null) {
        calculateMargin(curService, curIndex);
      }
    }
    setUpdatePriceField("");
  }, [isUpdatePriceField]);

  const onServiceInfoChange = (e, fieldName) => {
    let name = "";
    let fieldValue = "";
    if (fieldName !== undefined) {
      name = fieldName;
      fieldValue = e;
    } else {
      name = e?.target?.name ? e.target.name : e.name;
      fieldValue = e?.target?.value ? e.target.value : e.value;
    }
    fieldValue = fieldValue !== undefined ? fieldValue : "";
    const fieldInfo = name.split("_");

    const catalogServiceIds = [];
    const responseData = serviceType.map((service, index) => {
      const tempData = { ...service };
      if (
        parseInt(service.hesusCatalogServiceId, 10) ===
          parseInt(fieldInfo[1], 10) ||
        (service.hesusCatalogServiceCombination !== null &&
          ["product", "transport"].indexOf(fieldInfo[0]) !== -1)
      ) {
        if (["product", "transport", "unit"].indexOf(fieldInfo[0]) !== -1) {
          catalogServiceIds.push(service.hesusCatalogServiceId);
        }

        if (fieldInfo[0] === "quantity") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              quantity: {
                value: fieldValue,
                error: "",
                required: true,
                name: "quantity_" + service.hesusCatalogServiceId,
              },
            },
          };
          setUpdatePriceField(service.hesusCatalogServiceId);
          return tempData;
        }
        if (fieldInfo[0] === "unit") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              unit: {
                value: fieldValue,
                error: "",
                required: true,
                name: "unit_" + service.hesusCatalogServiceId,
              },
            },
          };
          return tempData;
        }

        if (fieldInfo[0] === "product") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              product: {
                value: fieldValue,
                error: "",
                required: true,
                name: "product_" + service.hesusCatalogServiceId,
              },
            },
          };
          return tempData;
        }
        if (fieldInfo[0] === "transport") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              transport: {
                value: fieldValue,
                error: "",
                required: true,
                name: "transport_" + service.hesusCatalogServiceId,
              },
            },
          };
          return tempData;
        }
        if (fieldInfo[0] === "purchasePrice") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              purchasePrice: {
                value: fieldValue,
                error: "",
                required: true,
                name: "purchasePrice_" + service.hesusCatalogServiceId,
              },
            },
          };
          setUpdatePriceField(service.hesusCatalogServiceId);
          return tempData;
        }
        if (fieldInfo[0] === "unitPrice") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              unitPrice: {
                value: fieldValue,
                error: "",
                required: true,
                name: "unitPrice_" + service.hesusCatalogServiceId,
              },
            },
          };
          setUpdatePriceField(service.hesusCatalogServiceId);
          return tempData;
        }
        if (fieldInfo[0] === "estimatedPurchasePrice") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              estimatedPurchasePrice: {
                value: fieldValue,
                error: "",
                required: true,
                name: "estimatedPurchasePrice_" + service.hesusCatalogServiceId,
              },
              purchasePrice: {
                ...service.serviceField.purchasePrice,
                error: "",
              },
            },
          };
          setUpdatePriceField(service.hesusCatalogServiceId);
          return tempData;
        }
        if (fieldInfo[0] === "estimatedPurchasePriceToggle") {
          const toggleValue =
            service.serviceField.estimatedPurchasePriceToggle.value;
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              estimatedPurchasePriceToggle: {
                value: !toggleValue,
                error: "",
                required: true,
                name:
                  "estimatedPurchasePriceToggle_" +
                  service.hesusCatalogServiceId,
              },
            },
          };
          setUpdatePriceField(service.hesusCatalogServiceId);
          return tempData;
        }
        if (fieldInfo[0] === "marginRate") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              marginRate: {
                value: fieldValue,
                error: "",
                required: true,
                name: "marginRate_" + service.hesusCatalogServiceId,
              },
            },
          };
          return tempData;
        }
        if (fieldInfo[0] === "comment") {
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              comment: {
                value: fieldValue,
                error: "",
                required: true,
                name: "comment_" + service.hesusCatalogServiceId,
              },
            },
          };
          return tempData;
        }
        if (fieldInfo[0] === "destination") {
          const address = {
            street: fieldValue.street.value,
            postalCode: fieldValue.postal.value,
            city: fieldValue.city.value,
            countryId: fieldValue.countryId.value,
            position: {
              latitude: fieldValue.latitude.value,
              longitude: fieldValue.longitude.value,
            },
          };
          const tempData = {
            ...service,
            serviceField: {
              ...service.serviceField,
              destination: {
                value: address,
                error: "",
                required: true,
                name: "destination_" + service.hesusCatalogServiceId,
              },
            },
          };
          return tempData;
        }
      }
      return tempData;
    });
    setCatalogServiceId(catalogServiceIds);
    setServiceType([...responseData]);
  };

  useEffect(() => {
    if (enquiryData?.id) {
      // fetch products info
      const requestId = isEditMode
        ? selectedSellingPrice.requestId
        : formData.requestId?.value ?? enquiryId;

      setProductsAPIError("");
      let url = `/products?subCategories=[${enquiryData?.subCategory.id}]&countries=[${countryId}]&requestId=${requestId}&limit=-1&orderBy=asc&orderColumn=name&status=1&listType=subList`;
      axios
        .get(url)
        .then((response) => {
          const productsData = response.data.products.map((productItem) => {
            return { label: productItem.name, value: productItem.id };
          });
          setProducts(productsData);
          setProductIds(response.data.products.map((obj) => obj.id).join());
          setProductFetch(true);
          setProductsAPIError("");
        })
        .catch((error) => {
          setProducts([]);
          setProductIds([]);
          setProductsAPIError(error.response?.data?.errors[0]?.message ?? "");
        });

      // fetch tranport info
      setTransportAPIError("");
      axios
        .get(
          `/transports?countries=[${countryId}]&limit=-1&orderBy=asc&orderColumn=orderIndex`
        )
        .then((response) => {
          const transportsData = response.data.transports.map(
            (transportItem) => {
              return { label: transportItem.name, value: transportItem.id };
            }
          );
          setTransportList(transportsData);
          setTransportAPIError("");
        })
        .catch((error) => {
          setTransportList([]);
          setTransportAPIError(error.response?.data?.errors[0]?.message ?? "");
        });
    }
  }, [enquiryData]);

  const validateForm = (data, serviceData) => {
    let isFormValid = true;
    if (page === "quote" && !data.requestId.value) {
      isFormValid = false;
      data.requestId.error = t("FIELD_REQUIRED");
    }
    if (!data.catalogService.value) {
      isFormValid = false;
      data.catalogService.error = t("FIELD_REQUIRED");
    }
    if (
      mainCurrency !== data.currency?.value &&
      Object.entries(userCurrency).length === 1
    ) {
      if (!data.currency.value) {
        isFormValid = false;
        data.currency.error = t("FIELD_REQUIRED");
      }
    }
    const responseData = serviceData.map((service) => {
      const tempData = { ...service };
      if (!service.serviceField.quantity.value) {
        isFormValid = false;
        tempData.serviceField.quantity.error = t("FIELD_REQUIRED");
      }
      if (
        service.serviceField.quantity.value &&
        !/^[0-9\b]+$/i.test(service.serviceField.quantity.value)
      ) {
        isFormValid = false;
        tempData.serviceField.quantity.error = t("INVALID_FORMAT");
      }
      if (!service.serviceField.unit.value) {
        isFormValid = false;
        tempData.serviceField.unit.error = t("FIELD_REQUIRED");
      }
      if (
        (!service.serviceField.product.value &&
          service.hesusServiceInfo.needProduct) ||
        (service.hesusCatalogServiceCombination !== null &&
          !service.serviceField.product.value)
      ) {
        isFormValid = false;
        tempData.serviceField.product.error = t("FIELD_REQUIRED");
      }
      if (
        (!service.serviceField.transport.value &&
          service.hesusServiceInfo.needTransport) ||
        (service.hesusCatalogServiceCombination !== null &&
          !service.serviceField.transport.value)
      ) {
        isFormValid = false;
        tempData.serviceField.transport.error = t("FIELD_REQUIRED");
      }

      if (
        !service.serviceField.destination.value &&
        service.hesusServiceInfo.needDestination
      ) {
        isFormValid = false;
        tempData.serviceField.destination.error = t("FIELD_REQUIRED");
      }

      if (
        !service.serviceField.unitPrice.value &&
        service.serviceField.unitPrice.value !== 0
      ) {
        isFormValid = false;
        tempData.serviceField.unitPrice.error = t("FIELD_REQUIRED");
      }
      if (
        service.serviceField.unitPrice.value &&
        !/^-?\d*[.,]?\d{0,2}$/.test(service.serviceField.unitPrice.value)
      ) {
        isFormValid = false;
        tempData.serviceField.unitPrice.error = t("INVALID_FORMAT");
      }

      if (
        service.hesusServiceInfo.needSolution &&
        service.serviceField?.solutionList?.value &&
        service.serviceField.solutionList.value.length > 0
      ) {
        let totalAllocation = 0;
        const selectedSolutions =
          service.serviceField?.solutionList?.value.filter(
            (solutionAllocation) => solutionAllocation.isSelected === true
          );
        totalAllocation = selectedSolutions.reduce(
          (n, { solution }) => n + solution.allocation,
          0
        );
        if (parseInt(totalAllocation, 10) !== 100) {
          isFormValid = false;
          tempData.serviceField.purchasePrice.value = null;
          tempData.serviceField.purchasePrice.error = t(
            "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
          );
        } else {
          tempData.serviceField.purchasePrice.error = "";
        }

        service.serviceField.solutionList.value.map(
          (solutionInfo, solutionIndex) => {
            if (solutionInfo.calculatedUnitPurchasePrice?.errors) {
              // for TransportTreatmentSeparated and TreatmentOnly
              if (
                (solutionInfo.priceType ===
                  priceTypes.TransportTreatmentSeparated ||
                  solutionInfo.priceType === priceTypes.TreatmentOnly) &&
                solutionInfo.isSelected &&
                service.hesusServiceInfo.needProduct &&
                !service.hesusServiceInfo.needTransport &&
                !solutionInfo.solution.unitPurchasePrice.treatment?.price
              ) {
                isFormValid = false;
                if (
                  !tempData.serviceField.solutionList.value[solutionIndex]
                    .solution.unitPurchasePrice?.treatment
                ) {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.unitPurchasePrice = {
                    treatment: {
                      price: "",
                      unit: service.serviceField.unitPrice.value,
                      error: t("FIELD_REQUIRED"),
                    },
                  };
                } else {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.unitPurchasePrice.treatment.error =
                    t("FIELD_REQUIRED");
                }
              }

              // for TransportTreatmentSeparated and TreatmentOnly
              if (
                (solutionInfo.priceType ===
                  priceTypes.TransportTreatmentSeparated ||
                  solutionInfo.priceType === priceTypes.TransportOnly) &&
                solutionInfo.isSelected &&
                !service.hesusServiceInfo.needProduct &&
                service.hesusServiceInfo.needTransport &&
                !solutionInfo.solution.unitPurchasePrice.transport?.price
              ) {
                isFormValid = false;
                if (
                  !tempData.serviceField.solutionList.value[solutionIndex]
                    .solution.unitPurchasePrice?.transport
                ) {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.unitPurchasePrice = {
                    transport: {
                      price: "",
                      unit: service.serviceField.unitPrice.value,
                      error: t("FIELD_REQUIRED"),
                    },
                  };
                } else {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.unitPurchasePrice.transport.error =
                    t("FIELD_REQUIRED");
                }
              }

              // for TransportTreatmentSeparated and TransportTreatment
              if (
                (solutionInfo.priceType ===
                  priceTypes.TransportTreatmentSeparated ||
                  solutionInfo.priceType === priceTypes.TransportTreatment) &&
                solutionInfo.isSelected &&
                service.hesusServiceInfo.needProduct &&
                service.hesusServiceInfo.needTransport &&
                !solutionInfo.solution.unitPurchasePrice.transportTreatment
                  ?.price
              ) {
                isFormValid = false;
                if (
                  !tempData.serviceField.solutionList.value[solutionIndex]
                    .solution.unitPurchasePrice?.transportTreatment
                ) {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.unitPurchasePrice = {
                    transportTreatment: {
                      price: "",
                      unit: service.serviceField.unitPrice.value,
                      error: t("FIELD_REQUIRED"),
                    },
                  };
                } else {
                  tempData.serviceField.solutionList.value[
                    solutionIndex
                  ].solution.unitPurchasePrice.transportTreatment.error =
                    t("FIELD_REQUIRED");
                }
              }
            }
          }
        );

        if (
          (!service.serviceField.purchasePrice.value ||
            service.serviceField.purchasePrice.value === "") &&
          service.serviceField.purchasePrice.value !== 0
        ) {
          isFormValid = false;
          tempData.serviceField.purchasePrice.error = t(
            "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
          );
        }
      }
      if (
        service.hesusServiceInfo.needSolution &&
        countryNeedSolution.needSolution === 0 &&
        service.serviceField.solutionList.value.length === 0
      ) {
        if (!service.serviceField.estimatedPurchasePriceToggle.value) {
          isFormValid = false;
          tempData.serviceField.purchasePrice.error = t(
            "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
          );
        }
        if (
          !service.serviceField.estimatedPurchasePrice.value ||
          service.serviceField.estimatedPurchasePrice.value === ""
        ) {
          isFormValid = false;
          tempData.serviceField.estimatedPurchasePrice.error =
            t("FIELD_REQUIRED");
          tempData.serviceField.purchasePrice.error = t(
            "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
          );
        }
        if (
          service.serviceField.estimatedPurchasePrice.value &&
          !/^-?\d*[.,]?\d{0,2}$/.test(
            service.serviceField.estimatedPurchasePrice.value
          )
        ) {
          isFormValid = false;
          tempData.serviceField.estimatedPurchasePrice.error =
            t("INVALID_FORMAT");
          tempData.serviceField.purchasePrice.error = t(
            "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
          );
        }
      }
      if (
        service.hesusServiceInfo.needSolution &&
        countryNeedSolution.needSolution === 1 &&
        service.serviceField.solutionList.value.length === 0
      ) {
        isFormValid = false;
        tempData.serviceField.purchasePrice.error = t(
          "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
        );
      }
      return tempData;
    });

    let rates = [];
    if (exchangeCurrency?.length > 0) {
      if (exchangeRate?.length > 0) {
        rates = exchangeRate.map((rateInfo) => {
          const tempData = { ...rateInfo };
          if (!rateInfo.rate || rateInfo.rate === "") {
            isFormValid = false;
            tempData.error = t("FIELD_REQUIRED");
          }
          return tempData;
        });
      }
      if (exchangeRate?.length === 0) {
        exchangeCurrency.map((exchange) => {
          rates.push({ id: exchange, rate: "", error: t("FIELD_REQUIRED") });
        });
      }
    }

    if (!isFormValid) {
      setFormData({ ...data });
      setServiceType([...responseData]);
      if (exchangeRate?.length > 0) setExchangeRate([...rates]);
    }
    return isFormValid;
  };

  const getFormData = () => {
    const hesusServicesData = [];
    serviceType.map((service) => {
      const solutionListData = [];
      if (
        service.serviceField?.solutionList?.value &&
        service.serviceField.solutionList.value.length > 0
      ) {
        service.serviceField.solutionList.value.map((solutionInfo) => {
          if (solutionInfo.isSelected) {
            solutionListData.push({
              id: solutionInfo?.solution?.id,
              solution: { id: solutionInfo?.id },
              allocation: solutionInfo?.solution?.allocation,
              allocationQuantity:
                solutionInfo?.solution?.allocationQuantity ?? 0,
              margin: solutionInfo?.solution?.margin ?? 0,
              unitPurchasePrice: !solutionInfo.calculatedUnitPurchasePrice
                ?.errors
                ? solutionInfo.calculatedUnitPurchasePrice
                : solutionInfo?.solution?.unitPurchasePrice,
              isActive: solutionInfo?.solution?.isActive ?? 1,
              koMargin: solutionInfo?.solution?.koMargin ?? null,
              koAllocation: solutionInfo?.solution?.koAllocation ?? "",
              koAllocationQuantity:
                solutionInfo?.solution?.koAllocationQuantity ?? "",
            });
          }
        });
      }

      let estimatedPurchasePriceData = null;
      let purchasePriceData =
        service.serviceField?.purchasePrice?.value ?? null;
      if (
        service.hesusServiceInfo.needSolution &&
        countryNeedSolution.needSolution === 0 &&
        service.serviceField.solutionList.value.length === 0
      ) {
        estimatedPurchasePriceData =
          service.serviceField?.estimatedPurchasePrice?.value;
        purchasePriceData = null;
      }

      if (!service.hesusServiceInfo.needSolution) {
        estimatedPurchasePriceData = null;
        purchasePriceData = null;
      }

      if (!service.hesusServiceInfo.needSolution) {
        purchasePriceData = service.serviceField?.purchasePrice?.value;
      }
      hesusServicesData.push({
        id: isEditMode ? service.serviceField?.sellingPriceItemId?.value : null,
        hesusCatalogService: { id: service.hesusCatalogServiceId },
        hesusService: { id: service.hesusServiceInfo.id },
        quantity: service.serviceField.quantity.value,
        unit: service.serviceField.unit.value,
        margin: service.serviceField.margin.value,
        marginRate: service.serviceField.marginRate.value,
        purchasePrice: purchasePriceData ?? null,
        estimatedPurchasePrice: estimatedPurchasePriceData,
        totalPrice: service.serviceField.totalPrice.value,
        comment: service.serviceField.comment.value,
        product:
          service.hesusServiceInfo.needProduct ||
          service.hesusCatalogServiceCombination !== null
            ? { id: service.serviceField.product.value }
            : null,
        transportType:
          service.hesusServiceInfo.needTransport ||
          service.hesusCatalogServiceCombination !== null
            ? { id: service.serviceField.transport.value }
            : null,
        unitPrice: parseFloat(
          String(service.serviceField.unitPrice.value).replace(",", ".")
        ),
        destination: service.hesusServiceInfo.needDestination
          ? {
              street: service?.serviceField.destination.value?.street,
              postalCode: service.serviceField.destination.value?.postalCode,
              city: service.serviceField.destination.value?.city,
              country: service.serviceField.destination.value?.countryId,
              position: {
                latitude:
                  service.serviceField.destination.value?.position?.latitude,
                longitude:
                  service.serviceField.destination.value?.position?.longitude,
              },
            }
          : null,
        solutions: solutionListData,
      });
    });

    const sellingPriceExchangeData = [];
    if (exchangeRate.length > 0) {
      exchangeRate.map((rateInfo) => {
        sellingPriceExchangeData.push({
          id: rateInfo?.exchangeRateId,
          currencyFrom: rateInfo.id,
          currencyTo: parseInt(formData.currency.value, 10),
          exchangeRate: parseFloat(rateInfo.rate),
        });
      });
    }
    const data = {
      id: isEditMode ? selectedSellingPrice.id : "",
      requestId: formData.requestId.value,
      label: formData.label.value,
      currency: { id: formData.currency.value },
      isActive: formData.isActive.value,
      totalMargin: 100,
      internalComment: formData.internalComment.value,
      totalPrice: 0,
      hesusCatalog: { id: formData.catalogService.value },
      services: hesusServicesData,
      createdBy: { id: userDetails.id },
      updatedBy: { id: userDetails.id },
      exchangeRates: sellingPriceExchangeData,
    };
    return data;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(formData, serviceType);
    if (isFormValid) {
      setSellingPriceSaveAPIError("");
      setSellingPriceSaveStatus(true);
      if (!id && !isEditMode) {
        // for create selling price
        axios
          .post(`/v2/sellingPrices`, getFormData())
          .then(() => {
            setSellingPriceSaveStatus(false);
            onRefreshData(true);
            onClose();
          })
          .catch((error) => {
            setSellingPriceSaveStatus(false);
            setSellingPriceSaveAPIError(error.response?.data?.message ?? "");
          });
      } else {
        // for edit selling price
        axios
          .put(`/v2/sellingPrices/${id}`, getFormData())
          .then(() => {
            setSellingPriceSaveStatus(false);
            onRefreshData(true);
            onClose();
          })
          .catch((error) => {
            setSellingPriceSaveStatus(false);
            setSellingPriceSaveAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  const mirrorAllocationInfo = (service, allocation, solutionId) => {
    if (
      service.hesusServiceInfo.needTransport &&
      (!service.hesusServiceInfo.needProduct ||
        service.hesusServiceInfo.needProduct === 0) &&
      service.hesusCatalogServiceCombination
    ) {
      const treatmetnService = serviceType.find(
        (type) =>
          type.hesusServiceInfo.needProduct &&
          (!type.hesusServiceInfo.needTransport ||
            type.hesusServiceInfo.needTransport === 0) &&
          type.hesusCatalogServiceCombination
      );
      if (treatmetnService) {
        const mirrorTreamnentSolution =
          treatmetnService.serviceField.solutionList.value.find(
            (solutionData) =>
              parseInt(solutionId, 10) === parseInt(solutionData.id, 10)
          );
        return mirrorTreamnentSolution?.solution?.allocation ?? allocation;
      }
    }
    return allocation;
  };

  const updateSolutionCheckedStatus = (
    solutionListData,
    serviceId,
    service
  ) => {
    const newdata = solutionListData.map((solutionData) => {
      if (!solutionIds[serviceId]) solutionIds[serviceId] = [];
      const checkboxStatus =
        solutionIds[serviceId].indexOf(solutionData.id) !== -1;
      let sellingPriceItemsolution = solutionData?.solution ?? null;
      if (solutionData.solution === null) {
        const allocationInfo =
          mirrorAllocationInfo(
            service,
            solutionData?.allocation,
            solutionData.id
          ) ?? 0;
        const quantity = service.serviceField.quantity.value;
        const allocationQuantityInfo = quantity
          ? twoDecimalPlaces((allocationInfo * quantity) / 100)
          : solutionData?.allocationQuantity;
        sellingPriceItemsolution = {
          id: "",
          allocation: allocationInfo,
          allocationQuantity: allocationQuantityInfo,
          solution: { id: solutionData.id },
          currency: solutionData.currency,
          unitPurchasePrice: {},
        };
      }
      if (solutionData.solution !== null) {
        const allocationInfo =
          mirrorAllocationInfo(
            service,
            solutionData.solution?.allocation,
            solutionData.id
          ) ?? 0;
        const quantity = service.serviceField.quantity.value;
        const allocationQuantityInfo = quantity
          ? twoDecimalPlaces((allocationInfo * quantity) / 100)
          : solutionData.solution?.allocationQuantity;
        sellingPriceItemsolution = {
          ...solutionData.solution,
          allocation: allocationInfo,
          allocationQuantity: allocationQuantityInfo,
        };
      }
      if (checkboxStatus) {
        if (
          solutionData.solutionTreatmentPrice?.currency.id &&
          formData.currency.value !==
            solutionData.solutionTreatmentPrice?.currency.id &&
          exchangeCurrency.indexOf(
            solutionData.solutionTreatmentPrice?.currency.id
          ) === -1
        ) {
          setExchangeCurrency([
            ...exchangeCurrency,
            solutionData.solutionTreatmentPrice?.currency.id,
          ]);
        }

        if (
          solutionData.solutionTransportPrice?.currency.id &&
          formData.currency.value !==
            solutionData.solutionTransportPrice?.currency.id &&
          exchangeCurrency.indexOf(
            solutionData.solutionTransportPrice?.currency.id
          ) === -1
        ) {
          setExchangeCurrency([
            ...exchangeCurrency,
            solutionData.solutionTransportPrice?.currency.id,
          ]);
        }
      }
      return {
        ...solutionData,
        isSelected: checkboxStatus,
        solution: sellingPriceItemsolution,
      };
    });
    return newdata;
  };

  /**
   * calculate margin for selling price item
   */

  const calculateMargin = (service, index) => {
    const data = { purchasePrice: {}, sellingPrice: {} };
    const priceType = getPriceType(
      service.hesusCatalogServiceCombination,
      service.hesusServiceInfo
    );
    const unitPrice = parseFloat(
      String(service.serviceField.unitPrice.value).replace(",", ".")
    );
    const quantity = service.serviceField.quantity.value;
    let purchasePrice = service.serviceField.purchasePrice.value;
    if (
      service.serviceField.solutionList.value.length === 0 &&
      service.serviceField.estimatedPurchasePriceToggle.value === true
    ) {
      purchasePrice = service.serviceField.estimatedPurchasePrice.value;
    }
    if (!service.hesusServiceInfo.needSolution) {
      purchasePrice = service.serviceField.purchasePrice.value;
    }
    if (
      unitPrice !== "" &&
      quantity !== "" &&
      purchasePrice !== "" &&
      (quantity || quantity === 0) &&
      (unitPrice || unitPrice === 0) &&
      (purchasePrice || purchasePrice === 0)
    ) {
      let priceTypeText = "";
      if (
        priceType === priceTypes.TransportTreatmentSeparated ||
        priceType === priceTypes.TransportOnly
      ) {
        data.purchasePrice.transport = purchasePrice;
        data.sellingPrice.transport = {
          price: unitPrice,
          quantity,
        };
        priceTypeText = "transport";
      }
      if (
        priceType === priceTypes.TransportTreatmentSeparated ||
        priceType === priceTypes.TreatmentOnly
      ) {
        data.purchasePrice.treatment = purchasePrice;
        data.sellingPrice.treatment = {
          price: unitPrice,
          quantity,
        };
        priceTypeText = "treatment";
      }
      if (priceType === priceTypes.TransportTreatment) {
        data.purchasePrice.transportTreatment = purchasePrice;
        data.sellingPrice.transportTreatment = {
          price: unitPrice,
          quantity,
        };
        priceTypeText = "transportTreatment";
      }
      axios
        .post("/general/v2/calculateMargin", data)
        .then((response) => {
          // serviceType[index].serviceField.totalPrice.value = response.data.total;
          serviceType[index].serviceField.marginRate.value =
            response.data[priceTypeText].rate;
          serviceType[index].serviceField.margin.value =
            response.data[priceTypeText].price;
          serviceType[index].serviceField.marginRate.error = "";
          serviceType[index].serviceField.margin.error = "";
          setServiceType([...serviceType]);
        })
        .catch((error) => handleApiError(error));
    }
  };

  const calculateAveragePurchasePrice = (service, index) => {
    service = serviceType[index];
    let totalAllocation = 0;
    const itemUnit = service.serviceField.unit.value;
    const itemTransport = service.serviceField.transport.value;

    const selectedSolutions = service.serviceField.solutionList.value.filter(
      (solution) => solution.isSelected === true
    );

    totalAllocation = selectedSolutions.reduce(
      (n, { solution }) => n + solution.allocation,
      0
    );

    let uppCheck = true;

    selectedSolutions.map((solutionInfo) => {
      const upp = !solutionInfo.calculatedUnitPurchasePrice?.errors
        ? solutionInfo.calculatedUnitPurchasePrice
        : solutionInfo?.solution?.unitPurchasePrice;
      if (
        (solutionInfo.priceType === priceTypes.TransportTreatmentSeparated ||
          solutionInfo.priceType === priceTypes.TreatmentOnly) &&
        solutionInfo.isSelected &&
        service.hesusServiceInfo.needProduct &&
        !service.hesusServiceInfo.needTransport &&
        (upp.treatment?.price === "" ||
          upp.treatment?.price === null ||
          upp.treatment?.price === undefined)
      )
        uppCheck = false;
      if (
        (solutionInfo.priceType === priceTypes.TransportTreatmentSeparated ||
          solutionInfo.priceType === priceTypes.TransportOnly) &&
        solutionInfo.isSelected &&
        !service.hesusServiceInfo.needProduct &&
        service.hesusServiceInfo.needTransport &&
        (upp.transport?.price === "" ||
          upp.transport?.price === null ||
          upp.transport?.price === undefined)
      )
        uppCheck = false;
      if (
        (solutionInfo.priceType === priceTypes.TransportTreatmentSeparated ||
          solutionInfo.priceType === priceTypes.TransportTreatment) &&
        solutionInfo.isSelected &&
        service.hesusServiceInfo.needProduct &&
        service.hesusServiceInfo.needTransport &&
        (upp.transportTreatment?.price === "" ||
          upp.transportTreatment?.price === null ||
          upp.transportTreatment?.price === undefined)
      )
        uppCheck = false;
    });

    if (totalAllocation === 100 && itemUnit && uppCheck) {
      const priceType = getPriceType(
        service.hesusCatalogServiceCombination,
        service.hesusServiceInfo
      );
      const modifiedSolutions = selectedSolutions.map((solutionItem) => {
        const upp = !solutionItem.calculatedUnitPurchasePrice?.errors
          ? solutionItem.calculatedUnitPurchasePrice
          : solutionItem?.solution?.unitPurchasePrice;
        const tempSolution = { ...upp };
        tempSolution.sollutionId = solutionItem.id;
        tempSolution.allocation = solutionItem.solution?.allocation ?? null;
        return tempSolution;
      });

      const requestData = {
        sellingPrice: {
          priceType,
          transportTypeId: itemTransport,
        },
        solutions: modifiedSolutions,
      };
      let priceTypeText = "";

      if (
        priceType === priceTypes.TransportTreatmentSeparated ||
        priceType === priceTypes.TreatmentOnly
      ) {
        requestData.sellingPrice.treatmentUnit = itemUnit;
        priceTypeText = "treatment";
      }
      if (
        priceType === priceTypes.TransportTreatmentSeparated ||
        priceType === priceTypes.TransportOnly
      ) {
        requestData.sellingPrice.transportUnit = itemUnit;
        priceTypeText = "transport";
      }
      if (priceType === priceTypes.TransportTreatment) {
        requestData.sellingPrice.transportTreatmentUnit = itemUnit;
        priceTypeText = "transportTreatment";
      }

      axios
        .post("/sellingPrices/calculateAveragePurchasePrice", requestData)
        .then((response) => {
          serviceType[index].serviceField.purchasePrice.value =
            response.data[priceTypeText].price;
          serviceType[index].serviceField.purchasePrice.error = "";
          setServiceType([...serviceType]);
          calculateMargin(service, index);
        })
        .catch((error) => handleApiError(error));
    } else if (totalAllocation !== 100) {
      serviceType[index].serviceField.purchasePrice.value = null;
      setServiceType([...serviceType]);
    }
  };

  // solution listing related code
  // fetch soolution based on array push rather fetchSolution flag
  useEffect(() => {
    if (catalogServiceId.length > 0 && productFetch) {
      const catalogServiceIdsSolutionApi = [];
      let url = "";
      setSellingPriceSolutionsAPIError("");
      const serviceDataWithSolutions = serviceType;
      catalogServiceId.map((catalogId) => {
        // const tempData = { ...service };
        const service = serviceType.find(
          (type) =>
            parseInt(catalogId, 10) === parseInt(type.hesusCatalogServiceId, 10)
        );
        url = "";
        if (service) {
          let solutionType = [];
          if (service.hesusCatalogServiceCombination !== null)
            solutionType = [1];
          if (service.hesusCatalogServiceCombination === null) {
            if (
              service.hesusServiceInfo.needTransport &&
              !service.hesusServiceInfo.needProduct
            )
              solutionType = [3];
            if (
              !service.hesusServiceInfo.needTransport &&
              service.hesusServiceInfo.needProduct
            )
              solutionType = [4, 1];
            if (
              service.hesusServiceInfo.needTransport &&
              service.hesusServiceInfo.needProduct
            )
              solutionType = [1, 2];
            if (
              !service.hesusServiceInfo.needTransport &&
              !service.hesusServiceInfo.needProduct
            )
              solutionType = [0];
          }
          if (
            service.hesusCatalogServiceCombination !== null &&
            (service.hesusServiceInfo.needTransport ||
              service.hesusServiceInfo.needProduct) &&
            service.serviceField.product.value &&
            service.serviceField.transport.value &&
            service.serviceField.unit.value !== ""
          ) {
            url = `/v2/sellingPrices/solutions?sellingPriceItemId=${
              service.serviceField.sellingPriceItemId.value
            }&solutionType=[${solutionType}]&requestId=${enquiryId}&transportId=${
              service.serviceField.transport.value ?? ""
            }&itemUnit=${service.serviceField.unit.value}&hesusServiceId=${
              service.hesusServiceInfo.id
            }&productIds=[${productIds}]&currency=${formData.currency.value}
            &limit=-1&orderBy=asc&orderColumn=name&status=1&stage="[7,8,9]"`;
          }
          // if combination id is null
          if (service.hesusCatalogServiceCombination === null) {
            if (
              service.hesusServiceInfo.needTransport &&
              service.hesusServiceInfo.needProduct &&
              service.serviceField.product.value &&
              service.serviceField.transport.value &&
              service.serviceField.unit.value !== ""
            ) {
              url = `/v2/sellingPrices/solutions?sellingPriceItemId=${
                service.serviceField.sellingPriceItemId.value
              }&solutionType=[${solutionType}]&requestId=${enquiryId}&transportId=${
                service.serviceField.transport.value ?? ""
              }&itemUnit=${service.serviceField.unit.value}&hesusServiceId=${
                service.hesusServiceInfo.id
              }&productIds=[${productIds}]&currency=${formData.currency.value}
              &limit=-1&orderBy=asc&orderColumn=name&status=1&stage="[7,8,9]"`;
            }
            if (
              service.hesusServiceInfo.needTransport &&
              !service.hesusServiceInfo.needProduct &&
              service.serviceField.transport.value &&
              service.serviceField.unit.value !== ""
            ) {
              url = `/v2/sellingPrices/solutions?sellingPriceItemId=${
                service.serviceField.sellingPriceItemId.value
              }&solutionType=[${solutionType}]&requestId=${enquiryId}&transportId=${
                service.serviceField.transport.value ?? ""
              }&itemUnit=${service.serviceField.unit.value}&hesusServiceId=${
                service.hesusServiceInfo.id
              }&currency=${formData.currency.value}
              &limit=-1&orderBy=asc&orderColumn=name&status=1&stage="[7,8,9]"`;
            }
            if (
              !service.hesusServiceInfo.needTransport &&
              service.hesusServiceInfo.needProduct &&
              service.serviceField.product.value &&
              service.serviceField.unit.value !== ""
            ) {
              url = `/v2/sellingPrices/solutions?sellingPriceItemId=${service.serviceField.sellingPriceItemId.value}&solutionType=[${solutionType}]&requestId=${enquiryId}&productIds=[${productIds}]&itemUnit=${service.serviceField.unit.value}&hesusServiceId=${service.hesusServiceInfo.id}&currency=${formData.currency.value}
              &limit=-1&orderBy=asc&orderColumn=name&status=1&stage="[7,8,9]"`;
            }
          }
          if (
            solutionType.length > 0 &&
            url &&
            service.hesusServiceInfo.needSolution
          ) {
            catalogServiceIdsSolutionApi.push(parseInt(catalogId, 10));
            setCatalogServiceIdSolutionApi(catalogServiceIdsSolutionApi);
            axios
              .get(url)
              .then((response) => {
                if (response?.data) {
                  let serviceIndex = "";
                  let appService = {};
                  serviceDataWithSolutions.map((newService, index) => {
                    if (
                      parseInt(newService.hesusCatalogServiceId, 10) ===
                      parseInt(catalogId, 10)
                    ) {
                      serviceIndex = index;
                      serviceDataWithSolutions[
                        index
                      ].serviceField.solutionList.value = updateSolutionCheckedStatus(
                        response?.data,
                        service.hesusServiceInfo.id,
                        newService
                      );
                      appService = serviceDataWithSolutions[index];
                    }
                  });
                  setServiceType([...serviceDataWithSolutions]);
                  const catalogServiceIdIndex =
                    catalogServiceIdsSolutionApi.indexOf(
                      parseInt(catalogId, 10)
                    );
                  if (catalogServiceIdIndex !== -1) {
                    catalogServiceIdsSolutionApi.splice(
                      catalogServiceIdIndex,
                      1
                    );
                    setCatalogServiceIdSolutionApi(
                      catalogServiceIdsSolutionApi
                    );
                  }
                  calculateAveragePurchasePrice(appService, serviceIndex);
                }
              })
              .catch((error) => handleApiError(error));
          } else {
            setSellingPriceSolutionsAPIError("");
          }
        }
      });

      setCatalogServiceId([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogServiceId, productFetch]);

  const mirrorTranportSolution = (e, solutionId, type) => {
    serviceType.map((service) => {
      if (
        service.hesusServiceInfo.needTransport &&
        (!service.hesusServiceInfo.needProduct ||
          service.hesusServiceInfo.needProduct === 0) &&
        service.hesusCatalogServiceCombination
      ) {
        onSellingPriceSolutionChange(
          e,
          solutionId,
          service.hesusCatalogServiceId,
          service.hesusServiceInfo.id,
          type
        );
      }
    });
  };

  const onSellingPriceSolutionChange = (
    e,
    solutionId,
    hesusServiceCatalogId,
    hesusServiceId,
    type,
    fieldName
  ) => {
    serviceType.map((service, index) => {
      if (
        parseInt(service.hesusCatalogServiceId, 10) ===
        parseInt(hesusServiceCatalogId, 10)
      ) {
        if (type === "solution") {
          service.serviceField.solutionList.value.map(
            (solution, solutionIndex) => {
              if (parseInt(solution.id, 10) === parseInt(solutionId, 10)) {
                serviceType[index].serviceField.solutionList.value[
                  solutionIndex
                ].isSelected = e.target.checked;
              }
              if (
                solution.solutionTransportPrice?.currency.id &&
                formData.currency.value ===
                  solution.solutionTransportPrice?.currency.id &&
                exchangeCurrency.indexOf(
                  solution.solutionTransportPrice?.currency.id
                ) === -1
              ) {
                setExchangeCurrency([
                  ...exchangeCurrency,
                  solution.solutionTransportPrice?.currency.id,
                ]);
              }
              if (
                solution.solutionTreatmentPrice?.currency.id &&
                formData.currency.value !==
                  solution.solutionTreatmentPrice?.currency.id &&
                exchangeCurrency.indexOf(
                  solution.solutionTreatmentPrice?.currency.id
                ) === -1
              ) {
                setExchangeCurrency([
                  ...exchangeCurrency,
                  solution.solutionTreatmentPrice?.currency.id,
                ]);
              }
            }
          );
          if (!solutionIds[hesusServiceId]) solutionIds[hesusServiceId] = [];

          if (e.target.checked) {
            solutionIds[parseInt(hesusServiceId, 10)].push(
              parseInt(solutionId, 10)
            );
            setSolutionIds(solutionIds);
          } else {
            const index =
              solutionIds[parseInt(hesusServiceId, 10)].indexOf(solutionId);
            if (index !== -1) {
              solutionIds[parseInt(hesusServiceId, 10)].splice(index, 1);

              setSolutionIds(solutionIds);
            }
          }

          setServiceType([...serviceType]);
        }
        if (type === "allocation") {
          service.serviceField.solutionList.value.map(
            (solution, solutionIndex) => {
              if (parseInt(solution.id, 10) === parseInt(solutionId, 10)) {
                const allocation = e.value;
                const quantity = service.serviceField.quantity.value;
                serviceType[index].serviceField.solutionList.value[
                  solutionIndex
                ].solution.allocation = allocation;
                serviceType[index].serviceField.solutionList.value[
                  solutionIndex
                ].solution.allocationQuantity = twoDecimalPlaces(
                  (allocation * quantity) / 100
                );
              }
            }
          );
          setServiceType([...serviceType]);
        }
        if (type === "upp") {
          service.serviceField.solutionList.value.map(
            (solution, solutionIndex) => {
              if (parseInt(solution.id, 10) === parseInt(solutionId, 10)) {
                if (fieldName === "treatment") {
                  if (
                    !serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice?.treatment
                  ) {
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice = {
                      treatment: {
                        price: e.target.value,
                        unit: serviceType[index].serviceField.unit.value,
                        error: "",
                      },
                    };
                  } else {
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice.treatment.price =
                      e.target.value;
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice.treatment.error = "";
                  }
                }
                if (fieldName === "transport") {
                  if (
                    !serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice?.transport
                  ) {
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice = {
                      transport: {
                        price: e.target.value,
                        unit: serviceType[index].serviceField.unit.value,
                        error: "",
                      },
                    };
                  } else {
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice.transport.price =
                      e.target.value;
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice.transport.error = "";
                  }
                }
                if (fieldName === "transportTreatment") {
                  if (
                    !serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice?.transportTreatment
                  ) {
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice = {
                      transportTreatment: {
                        price: e.target.value,
                        unit: serviceType[index].serviceField.unit.value,
                        error: "",
                      },
                    };
                  } else {
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice.transportTreatment.price =
                      e.target.value;
                    serviceType[index].serviceField.solutionList.value[
                      solutionIndex
                    ].solution.unitPurchasePrice.transportTreatment.error = "";
                  }
                }
              }
            }
          );
          setServiceType([...serviceType]);
        }
        calculateAveragePurchasePrice(service, index);
        if (type === "solution" || type === "allocation") {
          if (
            service.hesusServiceInfo.needProduct &&
            (!service.hesusServiceInfo.needTransport ||
              service.hesusServiceInfo.needTransport === 0) &&
            service.hesusCatalogServiceCombination
          ) {
            mirrorTranportSolution(e, solutionId, type);
          }
        }
      }
    });
  };

  const getPriceType = (hesusServiceCombination, hesusService) => {
    if (hesusServiceCombination) {
      if (
        hesusService.needProduct &&
        (!hesusService.needTransport || hesusService.needTransport === 0)
      )
        return 4;
      if (
        hesusService.needTransport &&
        (!hesusService.needProduct || hesusService.needProduct === 0)
      )
        return 3;
    }
    if (
      hesusService.needTransport === true &&
      hesusService.needProduct === true
    )
      return 2;
    if (
      hesusService.needTransport === true &&
      hesusService.needProduct === false
    )
      return 3;
    if (
      hesusService.needTransport === false &&
      hesusService.needProduct === true
    )
      return 4;
    if (
      hesusService.needTransport === false &&
      hesusService.needProduct === false &&
      hesusService.needSolution === false
    )
      return 4;
  };

  const getPriceTypeText = (priceType) => {
    let priceTypeText = "";

    if (
      priceType === priceTypes.TransportTreatmentSeparated ||
      priceType === priceTypes.TreatmentOnly
    ) {
      priceTypeText = "treatment";
    }
    if (
      priceType === priceTypes.TransportTreatmentSeparated ||
      priceType === priceTypes.TransportOnly
    ) {
      priceTypeText = "transport";
    }
    if (priceType === priceTypes.TransportTreatment) {
      priceTypeText = "transportTreatment";
    }
    return priceTypeText;
  };

  const getTreatmentPrice = (solutionItem) => {
    return solutionItem.calculatedUnitPurchasePrice?.treatment
      ? {
          price:
            solutionItem.calculatedUnitPurchasePrice?.treatment?.price ?? "",
          unit: solutionItem.calculatedUnitPurchasePrice?.treatment?.unit,
        }
      : solutionItem.solution?.purchasePrice &&
        solutionItem.solutionTreatmentPrice.unit !==
          data?.treatmentQuantityUnit?.value &&
        (unitArray.indexOf(solutionItem.solutionTreatmentPrice.unit) ||
          unitArray.indexOf(data?.treatmentQuantityUnit?.value))
      ? {
          price: solutionItem.solution?.purchasePrice ?? "",
          unit: solutionItem.solutionTreatmentPrice?.unit,
        }
      : {
          price: solutionItem.solutionTreatmentPrice?.price ?? "",
          unit: solutionItem.solutionTreatmentPrice?.unit,
        };
  };

  const getTransportPrice = (solutionItem) => {
    return solutionItem.calculatedUnitPurchasePrice?.transport
      ? {
          price:
            solutionItem.calculatedUnitPurchasePrice?.transport?.price ?? "",
          unit: solutionItem.calculatedUnitPurchasePrice?.transport?.unit,
        }
      : solutionItem.solution?.purchasePrice &&
        solutionItem.solutionTransportPrice.unit !==
          data?.transportQuantityUnit?.value &&
        (unitArray.indexOf(solutionItem.solutionTransportPrice.unit) ||
          unitArray.indexOf(data?.transportQuantityUnit?.value))
      ? {
          price: solutionItem.solution?.purchasePrice ?? "",
          unit: solutionItem.solution?.unit,
        }
      : {
          price: solutionItem.solutionTransportPrice?.price ?? "",
          unit: solutionItem.solutionTransportPrice?.unit,
        };
  };

  const getTransportTreatmentPrice = (solutionItem) => {
    return solutionItem.calculatedUnitPurchasePrice?.transportTreatment
      ? {
          price:
            solutionItem.calculatedUnitPurchasePrice?.transportTreatment
              ?.price ?? "",
          unit: solutionItem.calculatedUnitPurchasePrice?.transportTreatment
            ?.unit,
        }
      : solutionItem.solution?.purchasePrice &&
        solutionItem.solutionTransportPrice.unit !==
          data?.transportQuantityUnit?.value &&
        (unitArray.indexOf(solutionItem.solutionTransportPrice.unit) ||
          unitArray.indexOf(data?.transportQuantityUnit?.value))
      ? {
          price: solutionItem.solution?.purchasePrice ?? "",
          unit: solutionItem.solutionTransportPrice?.unit,
        }
      : {
          price: solutionItem.solutionTransportPrice?.price ?? "",
          unit: solutionItem.solutionTransportPrice?.unit,
        };
  };

  const getExchangeValue = (currencyId) => {
    const rateInfo = exchangeRate.find((rate) => rate.id === currencyId);
    return rateInfo ? String(rateInfo?.rate) : "";
  };

  const getExchangeError = (currencyId) => {
    const rateInfo = exchangeRate.find((rate) => rate.id === currencyId);
    return rateInfo ? rateInfo?.error : "";
  };

  const getExchangeRateObj = () => {
    const response = [];
    exchangeRate.map((rate) => {
      response.push({
        currencyFrom: parseInt(rate.id, 10),
        currencyTo: parseInt(formData.currency.value, 10),
        exchangeRate: parseFloat(rate.rate),
      });
    });
    return response;
  };

  const onExchangeRateChange = (e, currencyId) => {
    let rates = [];
    let value = "";
    // if value is not blank, then test the regex

    if (e.target.value === "" || /^-?\d*[.]?\d{0,2}$/.test(e.target.value)) {
      value = e.target.value;
    }
    const rateInfoData = exchangeRate.find(
      (rate) => parseInt(rate.id, 10) === parseInt(currencyId, 10)
    );

    if (rateInfoData) {
      rates = exchangeRate.map((rateInfo) => {
        const rateObject = { ...rateInfo };
        if (rateInfo.id === currencyId) {
          rateObject.rate = value;
          rateObject.error = "";
        }
        return rateObject;
      });
    } else {
      rates = exchangeRate;
      rates.push({
        id: currencyId,
        rate: value,
        error: "",
        exchangeRateId: null,
      });
    }
    setExchangeRate([...rates]);
    let uppTrigger = false;
    if (value) uppTrigger = true;
    uppTrigger = exchangeRate.map((rate) => {
      if (rate.rate === "") return false;
    });
    if (uppTrigger && !calculateUpp) setCalculateUpp(true);
  };

  // calculate UPP of solution when all exchange artes are defined
  const calculatedUnitPurchasePrice = () => {
    const payload = [];
    serviceType.map((service) => {
      const priceType = getPriceType(
        service.hesusCatalogServiceCombination,
        service.hesusServiceInfo
      );
      const priceTypeText = getPriceTypeText(priceType);
      const priceTypeTextUnit = priceTypeText + "Unit";
      const selectedSolutions = service.serviceField.solutionList.value;

      selectedSolutions.map((solution) => {
        const priceArray = {
          sellingPrice: {
            transportTypeId: service?.serviceField.transport?.value,
            currency: parseInt(formData.currency.value, 10),
            exchangeRates: getExchangeRateObj(),
          },
        };
        priceArray.sellingPrice[priceTypeTextUnit] =
          service?.serviceField.unit?.value;
        priceArray.serviceId = service.hesusServiceInfo.id;
        priceArray.solutionId = solution.id;
        if (priceTypeText === "transport") {
          priceArray[priceTypeText] = {
            purchasePrice: solution?.solutionTransportPrice?.price,
            purchaseUnit: solution?.solutionTransportPrice?.unit,
            currency: parseInt(
              solution?.solutionTransportPrice?.currency?.id,
              10
            ),
          };
        }
        if (priceTypeText === "treatment") {
          priceArray[priceTypeText] = {
            purchasePrice: solution?.solutionTreatmentPrice?.price,
            purchaseUnit: solution?.solutionTreatmentPrice?.unit,
            landfillTaxPrice: solution?.solutionTreatmentPrice?.tgap,
            landfillTaxUnit: solution?.solutionTreatmentPrice?.unit,
            currency: parseInt(
              solution?.solutionTreatmentPrice?.currency?.id,
              10
            ),
          };
        }

        if (priceTypeText === "transportTreatment") {
          if (solution.priceType === 2) {
            priceArray[priceTypeText] = {
              purchasePrice: solution?.solutionTransportPrice?.price,
              purchaseUnit: solution?.solutionTransportPrice?.unit,
              currency: parseInt(
                solution?.solutionTransportPrice?.currency?.id,
                10
              ),
            };
          }
          if (solution.priceType === 1) {
            priceArray.treatment = {
              purchasePrice: solution?.solutionTreatmentPrice?.price,
              purchaseUnit: solution?.solutionTreatmentPrice?.unit,
              landfillTaxPrice: solution?.solutionTreatmentPrice?.tgap,
              landfillTaxUnit: solution?.solutionTreatmentPrice?.unit,
              currency: parseInt(
                solution?.solutionTreatmentPrice?.currency?.id,
                10
              ),
            };
            priceArray.transport = {
              purchasePrice: solution?.solutionTransportPrice?.price,
              purchaseUnit: solution?.solutionTransportPrice?.unit,
              currency: parseInt(
                solution?.solutionTransportPrice?.currency?.id,
                10
              ),
            };
            priceArray.sellingPrice.treatmentUnit =
              service?.serviceField.unit?.value;
            priceArray.sellingPrice.transportUnit =
              service?.serviceField.unit?.value;
          }
        }
        payload.push(priceArray);
      });
      axios
        .post("/solutions/calculateUnitPurchasePrices", payload)
        .then((response) => {
          const uppResponse = {};

          response.data.map((value) => {
            if (!uppResponse[value.serviceId])
              uppResponse[value.serviceId] = { [value.solutionId]: value };
            else uppResponse[value.serviceId][value.solutionId] = value;
          });

          serviceType.map((service, index) => {
            response = uppResponse[service.hesusServiceInfo.id];
            if (response) {
              service.serviceField.solutionList.value.map(
                (solution, solutionIndex) => {
                  if (response[solution.id]) {
                    if (response[solution.id].hasOwnProperty("treatment")) {
                      serviceType[index].serviceField.solutionList.value[
                        solutionIndex
                      ].calculatedUnitPurchasePrice.treatment = {
                        price: response[solution.id].treatment.price,
                        unit: response[solution.id].treatment.unit,
                        error: response[solution.id].treatment.error,
                      };
                    }
                    if (response[solution.id].hasOwnProperty("transport")) {
                      serviceType[index].serviceField.solutionList.value[
                        solutionIndex
                      ].calculatedUnitPurchasePrice.transport = {
                        price: response[solution.id].transport.price
                          ? response[solution.id].transport.price
                          : "",
                        unit: response[solution.id].transport.unit,
                        error: response[solution.id].transport.error
                          ? response[solution.id].transport.error
                          : "",
                      };
                    }
                    if (
                      response[solution.id].hasOwnProperty("transportTreatment")
                    ) {
                      serviceType[index].serviceField.solutionList.value[
                        solutionIndex
                      ].calculatedUnitPurchasePrice.transportTreatment = {
                        price: response[solution.id].transportTreatment.price,
                        unit: response[solution.id].transportTreatment.unit,
                        error: response[solution.id].transportTreatment.error,
                      };
                    }
                    if (response[solution.id].hasOwnProperty("errors")) {
                      serviceType[index].serviceField.solutionList.value[
                        solutionIndex
                      ].calculatedUnitPurchasePrice.errors =
                        response[solution.id].errors;
                    }
                  }
                }
              );
              setServiceType([...serviceType]);
              calculateAveragePurchasePrice(service, index);
            }
          });
        })
        .catch((error) => {
          // serviceType[index].serviceField.purchasePrice.value = null;
          // serviceType[index].serviceField.purchasePrice.error = t(
          //   "SELLING_PRICE_ERROR_PURCHASE_PRICE_MISSING"
          // );
        });
    });
  };

  useEffect(() => {
    if (calculateUpp) {
      calculatedUnitPurchasePrice();
      setCalculateUpp(false);
    }
  }, [calculateUpp]);

  useEffect(() => {
    const currencyArray = [];
    let rates = [];
    let quoteCurrency = [];
    if (formDataUpdate) {
      quoteCurrency = exchangeCurrency;
      rates = exchangeRate;
    }

    serviceType.map((service) => {
      const selectedSolutions = service.serviceField.solutionList.value.filter(
        (solution) => solution.isSelected === true
      );

      selectedSolutions.map((solution) => {
        if (
          parseInt(formData.currency.value, 10) !==
            parseInt(solution?.solutionTransportPrice?.currency?.id, 10) &&
          !!solution?.solutionTransportPrice?.currency?.id &&
          quoteCurrency.indexOf(
            parseInt(solution?.solutionTransportPrice?.currency?.id, 10)
          ) === -1
        ) {
          quoteCurrency.push(
            parseInt(solution?.solutionTransportPrice?.currency?.id, 10)
          );
        }
        if (
          parseInt(formData.currency.value, 10) !==
            parseInt(solution?.solutionTreatmentPrice?.currency?.id, 10) &&
          !!solution?.solutionTreatmentPrice?.currency?.id &&
          quoteCurrency.indexOf(
            parseInt(solution?.solutionTreatmentPrice?.currency?.id, 10)
          ) === -1
        ) {
          quoteCurrency.push(
            parseInt(solution?.solutionTreatmentPrice?.currency?.id, 10)
          );
        }
      });
    });
    if (quoteCurrency?.length > 0) {
      quoteCurrency.map((currencyInfo) => {
        currencyArray.push(parseInt(currencyInfo, 10));

        const rateInfoData = exchangeRate.find(
          (rate) => rate.id === currencyInfo
        );
        if (rateInfoData) {
          rates.push(rateInfoData);
        } else {
          rates.push({
            id: currencyInfo,
            rate: "",
            error: "",
            exchangeRateId: null,
          });
        }
      });
    }
    setExchangeCurrency([...currencyArray]);
    setExchangeRate([...rates]);
    setFormDataUpdate(false);
    if (isCurrencyChange) {
      if (!calculateUpp) setCalculateUpp(true);
      setIsCurrencyChange(false);
    }
  }, [formData.currency.value, serviceType]);

  // useEffect(() => {
  //   let uppTrigger = false;
  //   if (exchangeRate?.length === 0) {
  //     uppTrigger = true;
  //   }
  //   if (uppTrigger && !calculateUpp) setCalculateUpp(true);
  // }, [exchangeRate]);

  return (
    <Dialog width="70rem">
      <>
        <HeaderWrapper>
          <Title>
            {isEditMode
              ? "#" + sellingPriceData?.id + " " + t("SELLING_PRICE")
              : t("SELLING_PRICE_NEW")}
            {page === "quote" && siteData?.name}
            {page === "quote" &&
              (enquiryData?.site ? " - " + enquiryData?.site.name : "")}
          </Title>
          <Button onClick={onClose} styles={styles.iconCloseButton}>
            <Image
              src={closeIcon}
              alt="close selling price popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>

        {exchangeCurrency.length > 0 && (
          <ExchangeRateWrapper>
            <ExchangeContainer>
              <GridRow>
                <CurrencyBanner>
                  {exchangeCurrency.map((exchange, exchangeIndex) => {
                    return (
                      <React.Fragment
                        key={"sp-quote-item-exchange-" + exchangeIndex}
                      >
                        <ExchangeRateLabel
                          color={
                            getExchangeError(exchange) !== "" ? "red" : "#fff"
                          }
                        >
                          {exchangeIndex === 0
                            ? t("QUOTE_EXCHANGE_RATE")
                            : "RATE"}{" "}
                          (
                          {currencyList[exchange] +
                            " -> " +
                            currencyList[formData.currency.value]}
                          )
                        </ExchangeRateLabel>
                        <TextInput
                          type="number"
                          onChange={(e) => {
                            onExchangeRateChange(e, exchange);
                          }}
                          disabled={false}
                          name="selling-price-exchange-rate-label"
                          id="selling-price-exchange-rate-label"
                          value={getExchangeValue(exchange)}
                          errorStyles={{ "font-style": "italic" }}
                          labelStyles={
                            getExchangeError(exchange) !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          inputStyles={
                            getExchangeError(exchange) !== ""
                              ? inputStylesError
                              : inputStyles
                          }
                          containerStyles={{
                            textAlign: "left",
                            width: "10%",
                          }}
                          error={getExchangeError(exchange)}
                        />
                      </React.Fragment>
                    );
                  })}
                </CurrencyBanner>
              </GridRow>
            </ExchangeContainer>
          </ExchangeRateWrapper>
        )}

        <FormBody>
          <EnquiryCatalogContainer>
            <Enquiries
              onSelect={onEnquirySelect}
              requestId={
                isEditMode
                  ? selectedSellingPrice.requestId
                  : formData.requestId?.value ?? enquiryId
              }
              isEditMode={isEditMode}
              isJobsite={isJobsite}
              enquiriesList={enquiryData}
              formData={formData}
              siteId={siteData?.id}
              countryId={countryId}
            />
            <CatalogServices
              setAllCatalogServiceList={setAllCatalogServiceList}
              setIsCurrencyChange={setIsCurrencyChange}
              formData={formData}
              isJobsite={isJobsite}
              isEditMode={isEditMode}
              setFormData={setFormData}
              isDisabled={isDisabled}
              countryId={countryId}
              requestId={
                isEditMode
                  ? selectedSellingPrice.requestId
                  : formData.requestId?.value ?? enquiryId
              }
            />
          </EnquiryCatalogContainer>
          {serviceType.length > 0 &&
            enquiryData?.id &&
            serviceType.map((serviceInfo, index) => {
              return (
                <ServiceTypeCondition
                  key={"serviceTypeCondition_" + index}
                  onSellingPriceSolutionChange={onSellingPriceSolutionChange}
                  isJobsite={isJobsite}
                  isEditMode={isEditMode}
                  isDisabled={isDisabled}
                  onChange={onServiceInfoChange}
                  currencyPosition={
                    countryCurrencyPosition[formData.currency.value]
                  }
                  currency={userCurrency[formData.currency.value]}
                  currencyId={formData.currency.value}
                  exchangeRate={exchangeRate}
                  serviceInfo={serviceInfo}
                  countryId={countryId}
                  transportList={transportList}
                  products={products}
                  productsAPIError={productsAPIError}
                  isTransportAPIError={isTransportAPIError}
                  enquiryId={enquiryId}
                  catalogServiceIdSolutionApi={catalogServiceIdSolutionApi}
                  countryNeedSolution={countryNeedSolution.needSolution}
                />
              );
            })}
          <GridRow>
            <TextInput
              type="textarea"
              label={t("SELLING_PRICE_ASSUMPTIONS")}
              name="seeling_price_assumptions"
              id="seeling_price_assumptions"
              isFloat
              onChange={onInternalCommentChange}
              placeholder={t("SELLING_PRICE_ASSUMPTIONS")}
              value={String(formData.internalComment.value)}
              errorStyles={{ "font-style": "italic" }}
              containerStyles={{ marginTop: "21px" }}
              error={formData.internalComment.error}
            />
          </GridRow>
        </FormBody>

        <ButtonWrapper>
          <ErrorMessage>{sellingPriceSaveAPIError}</ErrorMessage>
          <div>
            <Button styles={styles.submitButton} onClick={onSubmit}>
              <>
                {isSellingPriceSaving && <ClipLoader size={15} color="#fff" />}
                {!isSellingPriceSaving && t("SUBMIT")}
              </>
            </Button>
            <Button styles={styles.closeButton} onClick={onClose}>
              <>{t("CLOSE")}</>
            </Button>
          </div>
        </ButtonWrapper>
      </>
    </Dialog>
  );
};

AddEditSellingPrice.propTypes = {
  isEditMode: PropTypes.bool,
  id: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  isJobsite: PropTypes.bool,
  selectedSolutionsIds: PropTypes.array,
  page: PropTypes.string,
  countryId: PropTypes.number,
};

AddEditSellingPrice.defaultProps = {
  id: null,
  isEditMode: false,
  isJobsite: false,
  selectedSolutionsIds: [],
  page: "request",
  countryId: null,
};

export default withTranslation()(AddEditSellingPrice);
